import { render, staticRenderFns } from "./demographicSelect.vue?vue&type=template&id=4d6d0f4f&scoped=true&"
import script from "./demographicSelect.vue?vue&type=script&lang=js&"
export * from "./demographicSelect.vue?vue&type=script&lang=js&"
import style0 from "./demographicSelect.vue?vue&type=style&index=0&id=4d6d0f4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d0f4f",
  null
  
)

export default component.exports